const Title = () => {

  return (
    <div className="com-titleWithfollow hlp-marginBottom-15">
      <h1 className="com-title-section-xl hlp-marginBottom-40">Acumulado Grilla</h1>
    </div>
  )
}

export default Title;
